/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const routineChangePreviewBodyChangeTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangePreviewBodyChangeStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangePreviewBodyChangeAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const routineChangePreviewBodyChangeRotationCountExclusiveMin = 0;
export const routineChangePreviewBodyChangeRotationCountMax = 2147483647;

export const routineChangePreviewBodyChangeParticipantsItemOrdinalMin = 0;
export const routineChangePreviewBodyChangeParticipantsItemOrdinalMax = 19;

export const routineChangePreviewBodyChangeParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineChangePreviewBodyChangeParticipantsMax = 20;

export const routineChangePreviewBodyChangeRotationChangeTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangePreviewBodyChangeEndedAtOneOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewBodyChangeSectionChangeOneSectionsItemStartWeekdayMax = 7;

export const routineChangePreviewBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMin = 0;
export const routineChangePreviewBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMax = 1439;

export const routineChangePreviewBodyChangeSectionChangeOneSectionsItemEndWeekdayMax = 7;

export const routineChangePreviewBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMin = 0;
export const routineChangePreviewBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMax = 1439;

export const routineChangePreviewBodyChangeSectionChangeOneSectionsItemFullWeekDefault = false;
export const routineChangePreviewBodyChangeSectionChangeOneSectionsMax = 14;

export const routineChangePreviewBodyChangeSectionChangeOneTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangePreviewBodyChangeSectionChangeOneEffectiveLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangePreviewBodyExpectedVersionExclusiveMin = 0;
export const routineChangePreviewBodyExpectedVersionMax = 9007199254740991;

export const RoutineChangePreviewBody = zod.object({
  change: zod.object({
    teamId: zod.unknown().optional(),
    scheduleId: zod.unknown().optional(),
    timeZone: zod.unknown().optional(),
    timing: zod
      .union([
        zod.object({
          mode: zod.literal('immediate'),
        }),
        zod.object({
          mode: zod.literal('cycle'),
        }),
        zod.object({
          mode: zod.literal('date'),
          localDate: zod.iso.date().regex(routineChangePreviewBodyChangeTimingThreeLocalDateRegExp),
        }),
      ])
      .optional(),
    name: zod.string().optional(),
    startLocalDate: zod.iso
      .date()
      .regex(routineChangePreviewBodyChangeStartLocalDateRegExp)
      .optional(),
    anchorClockLocal: zod
      .string()
      .regex(routineChangePreviewBodyChangeAnchorClockLocalRegExp)
      .optional(),
    rotation: zod
      .object({
        unit: zod.enum(['day', 'week']),
        count: zod
          .int()
          .gt(routineChangePreviewBodyChangeRotationCountExclusiveMin)
          .max(routineChangePreviewBodyChangeRotationCountMax),
      })
      .optional(),
    participants: zod
      .array(
        zod.object({
          ordinal: zod
            .int()
            .min(routineChangePreviewBodyChangeParticipantsItemOrdinalMin)
            .max(routineChangePreviewBodyChangeParticipantsItemOrdinalMax),
          userId: zod.uuid().regex(routineChangePreviewBodyChangeParticipantsItemUserIdRegExp),
        }),
      )
      .min(1)
      .max(routineChangePreviewBodyChangeParticipantsMax)
      .optional(),
    effectiveLocalDate: zod.unknown().optional(),
    rotationChange: zod
      .object({
        action: zod.enum(['set', 'revise', 'cancel']),
        timing: zod
          .union([
            zod.object({
              mode: zod.literal('immediate'),
            }),
            zod.object({
              mode: zod.literal('cycle'),
            }),
            zod.object({
              mode: zod.literal('date'),
              localDate: zod.iso
                .date()
                .regex(routineChangePreviewBodyChangeRotationChangeTimingThreeLocalDateRegExp),
            }),
          ])
          .optional(),
        effectiveLocalDate: zod.unknown().optional(),
      })
      .optional(),
    endedAt: zod
      .union([
        zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(routineChangePreviewBodyChangeEndedAtOneOneRegExp),
          zod.literal('now'),
        ]),
        zod.null(),
      ])
      .optional(),
    sectionChange: zod
      .union([
        zod.object({
          action: zod.enum(['set', 'revise']),
          sections: zod
            .array(
              zod.object({
                startWeekday: zod
                  .int()
                  .min(1)
                  .max(routineChangePreviewBodyChangeSectionChangeOneSectionsItemStartWeekdayMax),
                startLocalMinute: zod
                  .int()
                  .min(
                    routineChangePreviewBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMin,
                  )
                  .max(
                    routineChangePreviewBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMax,
                  ),
                endWeekday: zod
                  .int()
                  .min(1)
                  .max(routineChangePreviewBodyChangeSectionChangeOneSectionsItemEndWeekdayMax),
                endLocalMinute: zod
                  .int()
                  .min(routineChangePreviewBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMin)
                  .max(routineChangePreviewBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMax),
                fullWeek: zod
                  .boolean()
                  .default(
                    routineChangePreviewBodyChangeSectionChangeOneSectionsItemFullWeekDefault,
                  ),
              }),
            )
            .min(1)
            .max(routineChangePreviewBodyChangeSectionChangeOneSectionsMax),
          timing: zod
            .union([
              zod.object({
                mode: zod.literal('immediate'),
              }),
              zod.object({
                mode: zod.literal('cycle'),
              }),
              zod.object({
                mode: zod.literal('date'),
                localDate: zod.iso
                  .date()
                  .regex(routineChangePreviewBodyChangeSectionChangeOneTimingThreeLocalDateRegExp),
              }),
            ])
            .optional(),
          effectiveLocalDate: zod.iso
            .date()
            .regex(routineChangePreviewBodyChangeSectionChangeOneEffectiveLocalDateRegExp)
            .optional(),
        }),
        zod.object({
          action: zod.literal('cancel'),
        }),
      ])
      .optional(),
  }),
  expectedVersion: zod
    .int()
    .gt(routineChangePreviewBodyExpectedVersionExclusiveMin)
    .max(routineChangePreviewBodyExpectedVersionMax),
});

export type RoutineChangePreviewBody = zod.input<typeof RoutineChangePreviewBody>;
export type RoutineChangePreviewBodyOutput = zod.output<typeof RoutineChangePreviewBody>;
